<template>
  <div class="distribution-wrapper">
    <UserInfo :user="user" :isActivityEmpty="true" />

    <Menu :items="menus" @on-change-menu="onChangeMenu" />

    <section class="rule-wrapper" v-if="menus[0].active">
      <p class="rule-item">① 请在您的公众号中将此链接设置为关键词【听课】的自动回复内容。裂变出的用户将通过此链接到您的公众号领取课程。</p>
      <p class="rule-item">① 请在您的公众号中将此链接设置为关键词【听课】的自动回复内容。裂变出的用户将通过此链接到您的公众号领取课程。</p>
      <p class="rule-item">① 请在您的公众号中将此链接设置为关键词【听课】的自动回复内容。裂变出的用户将通过此链接到您的公众号领取课程。</p>
      <p class="rule-item">① 请在您的公众号中将此链接设置为关键词【听课】的自动回复内容。裂变出的用户将通过此链接到您的公众号领取课程。</p>
    </section>

    <section class="detail-wrapper" v-if="menus[1].active">
      <section class="date-wrapper">
        <BtnPicker class="date-btn" :items="dateItems" @on-change-date="onChangeDate" />
        <datetime class="date-picker" v-model="dateItem" format="kkkk-LL-dd" />
      </section>

      <MpAccount :user="user" />
      <MpAccount :user="user" />
    </section>

    <section class="share-wrapper" v-if="menus[2].active">
      <article class="share-item">
        <h3>我的邀请码</h3>
        <p>请在您的公众号中将此链接设置为关键词<br />【听课】的自动回复内容。裂变出的用户将<br />通过此链接到您的公众号领取课程。</p>
        <div class="content">
          <label class="text code">{{inviteKey}}</label>
          <span class="copy-btn" @click="copy(inviteKey)">复制</span>
        </div>
      </article>

      <article class="share-item">
        <h3>我的邀请链接</h3>
        <p>请在您的公众号中将此链接设置为关键词<br />【听课】的自动回复内容。裂变出的用户将<br />通过此链接到您的公众号领取课程。</p>
        <div class="content">
          <label class="text link">{{inviteURL}}</label>
          <span class="copy-btn" @click="copy(inviteURL)">复制</span>
        </div>
      </article>

      <article class="share-item" v-if="posterURL">
        <h3>我的邀请海报</h3>
        <img class="poster" :src="posterURL" />
      </article>
    </section>

    <canvas id="canvas" class="canvas"></canvas>
  </div>
</template>

<script>
import posterBase from '../../../assets/h5/poster-base.png'

import Notes from '@/engine/Notes'
import UserInfo from '@/components/h5/UserInfo.vue'
import Menu from '@/components/h5/Menu.vue'
import BtnPicker from '@/components/h5/BtnPicker.vue'
import MpAccount from '@/components/h5/MpAccount.vue'

const state = {
  selectedDate: 'all',
}

const drawPoster = (vm, image, qrUrl) => {
  const canvas = document.getElementById('canvas')
  canvas.width = 640
  canvas.height = 1008
  if (canvas && canvas.getContext) {
    const ctx = canvas.getContext('2d')
    const img = new Image()
    img.setAttribute('crossOrigin', 'Anonymous')
    img.src = image
    img.onload = () => {
      ctx.drawImage(img, 0, 0)

      const qr = new Image()
      qr.setAttribute('crossOrigin', 'Anonymous')
      qr.src = qrUrl
      qr.onload = () => {
        ctx.drawImage(qr, 420, 740, 150, 150)

        try {
          vm.posterURL = canvas.toDataURL('image/png')
        } catch (error) {
          console.error(JSON.stringify(error))
        }
      }
    }
  }
}

export default {
  name: 'distribution',
  components: {
    UserInfo,
    Menu,
    BtnPicker,
    MpAccount,
  },
  data () {
    return {
      user: {},
      inviteKey: '',
      dateItem: '',
      posterURL: '',
      inviteURL: '',
      menus: [{
        id: 'rule',
        name: '分销规则',
        active: true,
      }, {
        id: 'detail',
        name: '收入详情',
        active: false,
      }, {
        id: 'share',
        name: '邀请好友',
        active: false,
      }],
      dateItems: [{
        name: '全部',
        value: 'all',
        isActive: true,
      }, {
        name: '本月',
        value: 'month',
        isActive: false,
      }, {
        name: '本周',
        value: 'week',
        isActive: false,
      }, {
        name: '本日',
        value: 'day',
        isActive: false,
      }],
    }
  },
  mounted () {
    this.user = this.globalData.user
    this.inviteKey = this.globalData.inviteKey
    this.inviteURL = `${location.origin}/h5/?appId=${this.globalData.appId}&inviterKey=${this.inviteKey}`

    Notes.generatePartnerMpQrCode().then(async ({ url }) => {
      drawPoster(this, posterBase, url)
    })
  },
  methods: {
    onChangeMenu: function (id) {
      this.menus = this.menus.map((item, index) => {
        if (item.id === id) {
          this.menuActiveIndex = index
        }
        return {
          ...item,
          active: item.id === id,
        }
      })
    },
    onChangeDate: function ({ value }) {
      this.dateItems = this.dateItems.map((item) => {
        if (item.value === value) {
          state.selectedDate = value
          this.dateItem = ''
        }
        return {
          ...item,
          isActive: item.value === value,
        }
      })
    },
    copy: function (link) {
      this.$copyText(link).then(() => {
        this.$toast('复制成功！')
      }, () => {
        this.$toast('复制失败，请刷新后重试！')
      })
    },
  },
  watch: {
    dateItem(date) {
      if (date) {
        state.selectedDate = date
        this.dateItems = this.dateItems.map((item) => {
          return {
            ...item,
            isActive: false,
          }
        })
      }
    },
  },
}
</script>

<style lang="scss">
.distribution-wrapper {
  .menu-wrapper {
    margin-top: 20px;

    .menu-list {
      display: flex;
      justify-content: space-around;
    }
  }

  .date-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 10px;
  }

  .date-btn {
    flex-shrink: 0;
  }

  .rule-wrapper {
    padding: 10px 20px 20px;
    font-size: 14px;
    color: #000;

    .rule-item {
      margin: 20px 0;
    }
  }

  .share-item {
    margin: 0 15px;
    padding: 30px 0;
    border-bottom: 1px solid #bbb;

    &:last-child {
      border-bottom: 0;
    }

    h3 {
      margin: 0;
      padding: 0 0 5px;
      font-size: 16px;
      line-height: 25px;
      color: #101010;
    }

    p {
      margin: 0;
      padding: 0 0 10px;
      font-size: 14px;
      color: #e51c23;
      text-align: center;
    }

    .poster {
      width: 100%;
    }

    .content {
      display: flex;
      align-items: center;

      .text {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 0;
        flex-grow: 1;
        flex-shrink: 1;
        height: 60px;
        border: 1px solid #000;
        border-radius: 20px;

        &.code {
          font-size: 36px;
          color: #e51c23;
        }

        &.link {
          padding: 5px 10px;
          font-size: 14px;
          line-height: 25px;
          color: #000;
          display: -webkit-box;
          word-break: break-all;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .copy-btn {
        display: inline-block;
        font-size: 14px;
        line-height: 40px;
        color: #e51c23;
        border: 1px solid #e51c23;
        border-radius: 21px;
        padding: 0 15px 0 35px;
        margin-left: 15px;
        background-image: url('../../../assets/h5/copy.png');
        background-repeat: no-repeat;
        background-size: 20px;
        background-position: 10px center;
      }
    }
  }

  .canvas {
    position: fixed;
    left: 200%;
    top: 200%;
  }
}
</style>
